import classNames from 'classnames';
import { Button, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import styles from './ErrorMessage.module.sass';

export type ErrorMessageProps = {
  title?: string;
  message?: string;
  retry?: () => void;
  className?: string;
};

export const ErrorMessage = ({ message, retry, className }: ErrorMessageProps) => {
  const { t } = useTranslation('global');

  const defaultMessage = t('errorMessage.defaultMessage');

  return (
    <div className={classNames(styles.container, className)}>
      <Text size="sm" mb="md">
        {message || defaultMessage}
      </Text>
      {retry && (
        <Button leftSection={<IconRefresh size={16} />} variant="outline" size="sm" onClick={retry}>
          {t('errorMessage.retry', 'Try Again')}
        </Button>
      )}
    </div>
  );
};
